const ops = {
  add: '新增',
  delete: '删除',
  query: '',
  update: '更新',
  modify: '修改'
}

const names = {
  patient_beds: '病人床位列表',
  calendar_dish_template: '日历排菜',
  certificate_management: '证书管理',
  patient_order_stat: '病人点餐情况',
  bus_finace_report: '营收报表',
  bus_purchasing_list: '净菜采购清单',
  batch_dish_statics: '分批次菜品统计',
  consume_person_statics: '就餐人员统计',
  consume_dish_statics: '菜品消费统计',
  home: 'CMS',
  demo1: '测试1',
  demo2: '测试2',
  demo_query_order: '查询订单',
  card_operate: '员工卡资料',
  cash_recharge: '现金充值',
  fast_recharge: '快速充值',
  supplement_recharge: '餐补充值',
  cash_red: '现金冲红',
  supplement_red: '餐补冲红',
  recharge_monthly_report: '充值月报表',
  monthly_statistical_statement: '月统计报表',
  demo_tabs: '餐段设置',
  order_query: '查询订单',
  order_detail: '订单详情',
  random_discount_setting: '随机优惠活动设置',
  hall_setting: '食堂设置',
  stall_setting: '食堂档口设置',
  position_setting: '职务设置',
  period_name_setting: '餐段名称设置',
  department_setting: '部门设置',
  period_setting: '餐段设置',
  matirial_purchasing_list: '采购清单',
  cooking_list: '烧制清单汇总',
  cooking_list_detail: '烧制清单',
  ayi_order_statics: '点餐员订单统计',
  op_order_statics: '操作员订单统计',
  ayi_on_accounts_query: '点餐员挂账对账查询',
  order_delivery: '订单配送',
  template_dish_arrangement: '模板排菜',
  template_dish_arrangement2: '模板排菜',
  base_categories: '基础菜品库',
  base_dishes: '基础菜品',
  dish_materials: '原材料',
  employee_reset_password: '重置密码',
  label_setting: '菜品标签设置',
  employee_setting: '员工设置',
  dish_setting: '手动排菜',
  plan_dish_setting: '手动排菜',
  waiter_setting: '点餐员',
  hallop_setting: '食堂操作员',
  manager_setting: '管理员设置',
  wehall_setting: '微信食堂',
  wehall_detail: '详情',
  batch_setting: '分批次就餐',
  subside_operate: '上传餐补数据',
  subside_operate2: '考勤餐补数据',
  batch_detail: '批次详情',
  account_withdraw: '账户提现',
  account_withdraw_logs: '提现记录',
  department_meal_statics: '部门就餐情况统计',
  hall_revenue_statics: '食堂营收查询',
  staffcar_setting: '办卡工本费设置',
  dish_comment_query: '菜品评价记录查询',
  dish_comment_statics: '菜品评价统计',
  comment_score_statics: '评价日历',
  expenses_record_statics: ' 消费记录查询',
  meal_supply_setting: '下月餐补额度设置',
  recharge_record_query: '充值记录查询',
  employee_name_modify: '修改员工姓名',
  home_page: '个人中心',
  advice_manage: '未读医嘱',
  name_dish_list: '命名排菜',
  name_template_detail: '命名排菜模板详情',
  order_evaluate_statics: '订单评价统计',
  order_evaluate_search: '订单评价搜索',
  employee_operate: '上传员工数据',
  consume_time_statics: '就餐高峰统计',
  expenditure_quantity_statics: '消费额点菜量统计',
  makeup_car: '补卡',
  change_car: '换卡',
  recharge_setting: '充值金额设置',
  checkout_car: '退卡',
  face_list: '人脸数据录入',
  subscriber_list: '订阅者列表',
  subscriber_listxcc: '三方支付对账单',
  administrator_takesmeal: '管理员取餐',
  delayUploadOrders_search: '查询延迟上传订单',
  refund_statics: '批量扣款记录查询',
  poundage_list: '工本费',
  withdrawal_list: '提现记录查询',
  // fingerprint_list: '指纹',
  asyn_list: '导出任务',
  outPayTradeNo_query: '充值未到账查询',
  health_query: '每日健康打卡统计',
  upload_img: '上传图片',
  usergroup_list: '用户组列表',
  autopay_list: '用户组扣款设置',
  cash_print: '收据打印',
  discount_list: '优惠活动设置',
  withdrawals: '对账单列表'
}

export function getTitle(op, name) {
  if (!name) {
    let hash = window.location.hash
    if (!hash) {
      return 'CMS'
    }
    let path = hash.substring(2, (hash.indexOf('?') !== -1) ? hash.indexOf('?') : hash.length)
    let paths = path.split('/')
    op = paths[1]
    name = paths[0]
  }
  name = name.replace(/-/g, '_')
  op = !op ? 'query' : op
  return ops[op] + names[name]
}



// WEBPACK FOOTER //
// ./src/pagename.js